import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

// Reusable calendar-style year picker (react-datepicker in showYearPicker mode).
// Keeps a single string year as its value and reports the picked year (or '' when
// cleared) via onChange — matching the string `year` contract the API expects.
//
// For "add to a list" cases (multi-year tag fields), pass value="" and use onChange
// to append; the picker never retains a selection because value stays empty.

const CURRENT_YEAR = new Date().getFullYear();

export default function YearPicker({
    value,
    onChange,
    minYear = CURRENT_YEAR - 24,
    maxYear = CURRENT_YEAR,
    placeholder = 'Select year',
    disabled = false,
    isClearable = true,
    className = 'form-control',
    id,
}) {
    const selected = value ? new Date(Number(value), 0, 1) : null;
    return (
        <DatePicker
            id={id}
            selected={selected}
            onChange={d => onChange(d ? String(d.getFullYear()) : '')}
            showYearPicker
            dateFormat="yyyy"
            minDate={new Date(minYear, 0, 1)}
            maxDate={new Date(maxYear, 11, 31)}
            placeholderText={placeholder}
            disabled={disabled}
            isClearable={isClearable}
            className={className}
            wrapperClassName="d-block"
        />
    );
}
